(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/challenge/assets/javascripts/components/xperten.js') >= 0) return;  svs.modules.push('/modules/challenge/assets/javascripts/components/xperten.js');
"use strict";


const mapStateToProps = (state, _ref) => {
  let {
    drawNumber
  } = _ref;
  const currentDraw = svs.challenge.helpers.getDrawByDrawNumber(drawNumber, state);
  const rowPrice = parseInt(currentDraw.rowPrice, 10);
  const coupon = svs.challenge.helpers.getCouponByDrawNumber(state, drawNumber);
  return {
    baseRow: coupon.baseRow,
    drawNumber,
    numberOfThreewayEvents: currentDraw.numberOfThreewayEvents,
    rowPrice,
    selectedXpert: coupon.xperten.selectedXpert,
    xperter: svs.challenge.constants.XPERTEN[rowPrice]
  };
};
const {
  startEditBaseRow,
  generateXpert,
  closeXperten
} = svs.challenge.actions;
svs.challenge.Xperten = ReactRedux.connect(mapStateToProps, {
  closeXperten,
  generateXpert,
  startEditBaseRow
})(svs.sport.xperten.XpertenWrapper);

 })(window);